import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { createTheme } from "react-data-table-component";
import Layout from "../../../layout/default";
import Block from "../../../components/Block/Block";
import { Icon } from "../../../components";
// import DataTable from "../../../components/DataTable/DataTable";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import React from "react";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import axios from "axios";
import api from "../../../../src/services/auth/api";

// const baseURL = process.env.SSP_BASE_URL_BACKEND;
// const baseURL = "http://127.0.0.1:8000/api/";


function CategoryList() {
  const [listData, setListData] = useState({});
  const [page, setPage] = useState(0);
  const countPerPage = 5;
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  // const _params = { params: { pageNumber: page, size: countPerPage } };
  const _params = { params: {} };

  const getList = () => {
    setLoading(true);
    const response = api
      .get(`${process.env.REACT_APP_HOST}api/category-get-all-paginated`, _params)
      .then((response) => {
        setListData(response.data.data.data);
        setTotalRows(response.data.data.pagination.total);
        setLoading(false);
      })
      .catch((err) => {
        setListData({});
        setLoading(false);
      });
  };

  useEffect(() => {
    getList();
  }, [page]);

  const navigate = useNavigate();
  const handleView = (_id) => {
    navigate(`/shop/admin/category-view/${_id}`);
  };

  const handleEdit = (_id) => {
    navigate(`/shop/admin/category-edit/${_id}`);
    // navigate("/shop/categoryList");
  };

  const deleteError = () => {
    Swal.fire({
      icon: "error",
      title: "Delete attempt was not successful",
      text: "Something went wrong!",
    });
  };

  const deleteConfirm = (_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "It will delete permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      debugger;
      if (result.value) {
        const response = api
          .delete(`${process.env.REACT_APP_HOST}api/category/${_id}`)
          .then((response) => {
            debugger;
            if (response.data.success) {
              deleteConfirm(_id);
              getList();
              Swal.fire(
                "Deleted",
                "You successfully deleted this record",
                "success"
              );
            } else {
              deleteError();
            }
          })
          .catch((err) => {
            deleteError();
          });
        // Swal.fire("Deleted", "You successfully deleted this record", "success");
      }
      // else
      // {
      //   console.log(result.value);
      //   Swal.fire("Cancelled", "Your record is not deleted", "info");
      // }
    });
  };

  const createCategory = (categoryData) => {
    const token = "${token}"; // Replace with your actual token
    axios.post(`${process.env.REACT_APP_HOST}api/category/create`, categoryData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    })
      .then(response => {
        Swal.fire('Success', 'Category created successfully', 'success');
        getList(); // Refresh the list after creation
      })
      .catch(error => {
        Swal.fire('Error', 'Failed to create category', 'error');
      });
  };


  createTheme(
    "solarized",
    {
      text: {
        primary: "#004b8e",
        secondary: "#2aa198",
      },
      background: {
        default: "#fff",
      },
      context: {
        background: "#cb4b16",
        text: "#FFFFFF",
      },
      divider: {
        default: "#d3d3d3",
      },
      action: {
        button: "rgba(0,0,0,.54)",
        hover: "rgba(0,0,0,.02)",
        disabled: "rgba(0,0,0,.12)",
      },
    },
    "light"
  );

  const customStyles = {
    rows: {
      style: {
        minHeight: "45px", // override the row height
      },
    },
    headCells: {
      style: {
        backgroundColor: "#1e67a8",
        color: "#fff",
        fontSize: "14px",
        paddingLeft: "8px", // override the cell padding for head cells
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
      },
    },
  };

  const categoryListDataColumns = [
    {
      name: "action",
      cell: (row) => (
        //   Button style
        <div className="text-start w-100">
          {/* <Button variant="primary" size="sm" onClick={() => handleView(row.id)}> */}
          <Button
            variant="primary"
            size="sm"
            onClick={() => handleView(row.id)}
          >
            View
          </Button>
          <Button
            variant="primary"
            size="sm"
            className="ms-2"
            onClick={() => handleEdit(row.id)}
          >
            Edit
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={() => deleteConfirm(row.id)}
            className="ms-2"
          >
            Delete
          </Button>
        </div>
      ),
      sortable: false,
      hide: "md",
    },
    {
      name: "Title",
      selector: (row) => row.title,
      cell: (row) => <span>{row.title}</span>,
      sortable: true,
      hide: "md",
    },
    {
      name: "Description",
      selector: (row) => row.description,
      cell: (row) => <span>{row.description}</span>,
      sortable: true,
      hide: "md",
    },
    {
      name: "Image",
      selector: (row) => row.image_url,
      cell: (row) => <span>{row.image_url}</span>,
      sortable: true,
      hide: "md",
    },
    // {
    //   name: "Price",
    //   selector: (row) => row.price,
    //   cell: (row) => <span>{row.price}</span>,
    //   sortable: true,
    //   hide: "md",
    // },
  ];

  return (
    <Layout title="category List">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Link
                  to="/shop/admin/admin-panel"
                  className="btn btn-primary btn-md d-md-none"
                >
                  <span>Go To Panel</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/shop/admin/admin-panel"
                  className="btn btn-primary d-none d-md-inline-flex"
                >
                  <span>Go To Panel</span>
                </Link>
              </li>
            </ul>
          </Block.HeadContent>
          <Block.HeadContent>
            <Block.Title tag="h2">Category List</Block.Title>
          </Block.HeadContent>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Link
                  to="/shop/admin/category"
                  className="btn btn-primary btn-md d-md-none"
                >
                  <Icon name="plus" />
                  <span>Create</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/shop/admin/category"
                  className="btn btn-primary d-none d-md-inline-flex"
                >
                  <Icon name="plus" />
                  <span>Create</span>
                </Link>
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card>
          <DataTable
            tableClassName="data-table-head-light table-responsive"
            columns={categoryListDataColumns}
            data={listData}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationPerPage={countPerPage}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            onChangePage={(page) => setPage(page - 1)}
            progressPending={loading}
            theme="solarized"
            customStyles={customStyles}
          />
        </Card>
      </Block>
    </Layout>
  );
}

export default CategoryList;
